<template>
  <v-app>
    <Sidebar v-if="!isMobile" />
    <v-container id="main" v-if="!isMobile">
      <transition name="component-fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-container>
    <v-container v-if="isMobile">
      <v-card >
        <v-card-title>
          🛑🚧Mil disculpas🚧🛑
        </v-card-title>
        <v-card-subtitle>
          No brindamos soporte para móviles
        </v-card-subtitle>
        <v-card-text>
          <ol>
            <li>
              Tampoco soportamos tablets o pantallas de menos de 960px de ancho
              <ul>
                <li>
                  Pricipalmente porque el sistema esta pensado para uso exclusivo en una PC
                    dentro del establecimiento.
                </li>
              </ul>
            </li>
            <li>Por favor visitanos usando tu computadora.</li>
            <li>Si te interesa usar la app desde móviles por favor, dejanos saber.</li>
          </ol>
        </v-card-text>
      </v-card>
    </v-container>
    <NuevoClienteModal />
    <LoadingIndicator />
    <SuccessModal />
  </v-app>
</template>

<script>
import NuevoClienteModal from "./components/NuevoClienteModal";
import LoadingIndicator from "./components/LoadingIndicator";
import Sidebar from "./components/Navigation/Sidebar";
import SuccessModal from "./components/SuccessModal.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: 'App',

  components: {
    Sidebar,
    NuevoClienteModal,
    SuccessModal,
    LoadingIndicator
  },

  data: () => ({
    mobile: false,
  }),
  computed: {
    ...mapGetters(["isLoadingIndicatorOpen"]),
    isMobile: function () {
      // return this.mobile;
      return this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs';
    },
    loadingIndicator: {
      get: function () {
        return this.isLoadingIndicatorOpen;
      },
      set: function (payload) {
        this.showLoadingIndicator(payload);
      },
    },
  },
  methods: {
    ...mapActions(["showLoadingIndicator"]),
    onResize: function () {
      this.mobile = window.innerWidth <= 1000;
    },
    // checkMobile: function(){
    //   this.mobile = this.$vuetify.breakpoint.name == 'xs';
    //   console.log("isMobile? ", this.mobile);
    // }
  },
};
</script>

<style>
#main {
  margin-left: 5.5vw; /*Allow space for the sidebar*/
  padding: 0 1% 0 0;
  max-width: 94.5%;
}
</style>